import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleBulkImportUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          d="M24.485 29.004c1.089.52 2.287.833 3.568.833a8.204 8.204 0 003.568-.833h.432c3.313 0 6 2.688 6 6v1.5a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5v-1.5c0-3.312 2.688-6 6-6zm-8.626-3.4c.653.313 1.372.5 2.141.5.769 0 1.49-.187 2.14-.5h.26c1.454 0 2.708.863 3.276 2.106-.804-.281-5.383.455-6.276 3.894h-3.9a1.5 1.5 0 01-1.5-1.5v-.9a3.6 3.6 0 013.6-3.6zm20 0c.654.313 1.372.5 2.141.5.769 0 1.49-.187 2.14-.5h.26a3.6 3.6 0 013.6 3.6v.9a1.5 1.5 0 01-1.5 1.5h-3.7c-.83-3.322-5.518-4.349-6.452-3.945a3.601 3.601 0 013.252-2.055zM28.053 18a4.812 4.812 0 014.814 4.814 4.812 4.812 0 01-4.814 4.815 4.812 4.812 0 01-4.814-4.815A4.812 4.812 0 0128.053 18zm9.895-1a3.646 3.646 0 013.647 3.648 3.646 3.646 0 01-3.647 3.647 3.646 3.646 0 01-3.648-3.647A3.646 3.646 0 0137.948 17zm-19.895 0a3.646 3.646 0 013.648 3.648 3.646 3.646 0 01-3.648 3.647 3.646 3.646 0 01-3.648-3.647A3.646 3.646 0 0118.053 17z"
          fill="#FFF"
        />
        <circle fill="#CCC" cx={38} cy={36} r={8} />
        <path
          d="M34.28 35.717l3.334-3.379a.2.2 0 01.342.137L38 35h3.8c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2H38v2.517a.2.2 0 01-.341.142L34.28 36.28a.4.4 0 01-.002-.564z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgPicCircleBulkImportUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleBulkImportUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleBulkImportUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
